var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"vxeGrid",attrs:{"auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"loading":_vm.loading,"data":_vm.tableData,"columns":_vm.tableColumns,"size":"mini","height":300,"border":"outer"},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"totalSalePrice",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.v_totalSalePrice || '0')+" "+_vm._s(row.salesCurrencyUnit || '')+" ")]}},{key:"shipmentRateHeader",fn:function(ref){
var column = ref.column;
return [_c('span',[_c('span',[_vm._v(_vm._s(column.title)+" ")]),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"(已出货票数 / 总出货票数) * 100","placement":"top"}},[_c('i',{staticClass:"el-icon-question"})])],1)]}},{key:"shipmentRate",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('b-progress',{attrs:{"variant":row.shipmentRate <= 20
              ? 'danger'
              : row.shipmentRate > 20 && row.shipmentRate <= 40
              ? 'warning'
              : row.shipmentRate > 40 && row.shipmentRate <= 60
              ? 'secondary'
              : row.shipmentRate > 60 && row.shipmentRate <= 80
              ? 'info'
              : row.shipmentRate > 80
              ? 'success'
              : '',"height":"0.5rem","value":row.shipmentRate,"animated":""}}),_c('p',{staticStyle:{"font-size":"12px","margin":"0px"}},[_vm._v(" "+_vm._s(row.shipmentRate)+"% ")])],1)]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }